import CookieUtil from '../util/cookieUtil';
class cookieCheck {
    constructor() {

        this.modalFoundationArray = new Array();

        if ($('#localization-modal').length > 0) {
            this.modalFoundationArray.push($('#localization-modal'));
        }
        if ($('#golive-country-modal').length > 0) {
            this.modalFoundationArray.push($('#golive-country-modal'));
        }
        this.cookieBanner = $('#cookie-alert');
        this.cookieBanner.on('click', '.button', (event) => {
            event.preventDefault();
            CookieUtil.setCookie('Cookie_Banner', 'ACCEPTED', 365);
            this.cookieBanner.hide();
        });
    }

    cookieSid() {

        if (CookieUtil.getCookie('Cookie_Banner') == '') {
            var previousSessionID = window.localStorage.getItem('previousSid');
            var currentSessionID = CookieUtil.getCookie('sid');
    
            if (!previousSessionID && currentSessionID) {
                previousSessionID = currentSessionID;
    
                window.localStorage.setItem('previousSid', previousSessionID);
                this.modalFoundationArray.forEach(function (modal) {
                    modal.foundation('open');
                });
                this.cookieBanner.show();
            } else if (previousSessionID && previousSessionID === currentSessionID) {
                this.modalFoundationArray.forEach(function (modal) {
                    modal.foundation('close');
                });
                this.cookieBanner.hide();
            } else {
                previousSessionID = '';
                window.localStorage.removeItem('previousSid');
            }
        }
    }
}

const CookieCheck = new cookieCheck();
export default CookieCheck;


// WEBPACK FOOTER //
// ./assets/scripts/components/cookie.js